import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bulma'
import '@/assets/bulma-badge.min.css'
import '@/assets/alertify.min.css'
import '@/assets/default.min.css'
import * as Sentry from "@sentry/vue";

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'


import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'


import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret,faCheck,faUser,faLock,faDownload,faBell,faSignOutAlt} from '@fortawesome/free-solid-svg-icons'
import { faTwitter } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon, } from '@fortawesome/vue-fontawesome'

library.add(faUserSecret,faCheck,faUser,faLock,faTwitter,faDownload,faBell,faSignOutAlt)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Sentry.init({
  Vue,
  dsn: "https://d0755c828c9b449d8475ef9c99b1331d@o4505042413355008.ingest.sentry.io/4505042416762880",
  integrations: [
    new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracePropagationTargets: ["localhost","router.com","faibamkononi.com", /^\//],
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});


let suscribe = store.subscribe((mutation, state) => {
  if(mutation.type === "setUser"){
    Sentry.setUser({ username: mutation.payload.userName });
  }
})

var app = new Vue({
  el:'#app',
  router,
  store,
  render: h => h(App)
})

export default{
  app:app
}
